import Box from '@mui/material/Box';
import { ConfirmationDialogProvider } from '@openx/components-core/lib/Dialog/ConfirmationDialog/ConfirmationDialogProvider';
import { EnvironmentOverrideBar } from '@openx/components-core/lib/EnvironmentOverrideBar/EnvironmentOverrideBar';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { OpenXAgentContextProvider } from '@openx/components-openx-agent/context/OpenXAgentContextProvider';
import { usePendo } from '@openx/utils/lib/pendo/pendo';
import { Outlet } from 'react-router';
import type { Session } from '../../components/AuthContext/types';
import { PENDO_API_KEY } from '../../config';
import { useIsAllowed } from '../../configs/permission/utils/useIsAllowed';
import { Navbar } from './components/Navbar/Navbar';
import { Sidenav } from './components/Sidenav/Sidenav';
import { StyledLayout } from './Dashboard.style';
import { useDashboard } from './hook/useDashboard';

export const Dashboard = () => {
  const { currentUser, session, handleHamburgerClick, handleLogout, loading, isSideNavOpen } = useDashboard();

  if (loading) {
    return <Loader />;
  }

  return (
    <ConfirmationDialogProvider>
      {session && currentUser ? (
        <DashboardContent
          session={session}
          isSideNavOpen={isSideNavOpen}
          onHamburgerClick={handleHamburgerClick}
          onLogoutClick={handleLogout}
        />
      ) : null}
    </ConfirmationDialogProvider>
  );
};

type DashboardContentProps = {
  session: Session;
  isSideNavOpen: boolean;
  onHamburgerClick: () => void;
  onLogoutClick: () => void;
};

const DashboardContent = ({ session, isSideNavOpen, onHamburgerClick, onLogoutClick }: DashboardContentProps) => {
  const { isAllowed } = useIsAllowed();

  usePendo({
    apiKey: PENDO_API_KEY,
    email: session.email,
    organizationType: session.account.organization_type,
  });

  return (
    <OpenXAgentContextProvider isAllowed={isAllowed} userName={session.first_name ?? ''}>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <EnvironmentOverrideBar />
        <StyledLayout isOpen={isSideNavOpen}>
          <Navbar
            userName={session.fullName || 'LOCAL DEVELOPER'}
            onLogoutClick={onLogoutClick}
            accountName={session.account.name}
            showHelpIcon={false}
            // searchComponent={globalSearchComponent}
            onHamburgerClick={onHamburgerClick}
          />
          <Sidenav />
          <Box
            id="dashboard-content"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              overflowX: 'clip',
              gridRow: 2,
              gridColumn: '2',
              overflow: 'auto',
            }}
          >
            <Outlet />
          </Box>
        </StyledLayout>
      </Box>
    </OpenXAgentContextProvider>
  );
};
